<template>
  <div class="importDXF">
    <div class="topButton">
      <div class="upload">
        <!--上传按钮-->
        <el-upload  :action="action"  :on-success="uploadSuc"  :on-error="uploadErr" :on-exceed="uploadMore" :on-remove="uploadRem"  :file-list="fileList" title="点击上传DXF数据EXCEL表格" auto-upload show-file-list :limit="1" :with-credentials="true" style="display: flex;">
          <el-button  type="primary" class="uploadBut">+&nbsp;上传文件</el-button>
        </el-upload>
      </div>

      <div class="save">
        <!--保存区-->
        <el-button type="info" @click="saveCase" :disabled="repeat">保存DXF数据</el-button>
      </div>
    </div>

      <el-tabs type="border-card" class="tabs">
        <el-tab-pane label="DXF环境信息">
          <div class="data" ref="dataEnv">
            <!--表格组件-->
            <el-table ref="envDXF" tooltip-effect="dark" border highlight-current-row  :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table" >
              <el-table-column v-for="(item,index) in tableTitleEnv" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
              </el-table-column>
            </el-table>
            <!--分页器-->
            <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="DXF障碍物信息">
          <div class="data" ref="dataOri">
            <!--表格组件-->
            <el-table ref="oriDXF" tooltip-effect="dark" border highlight-current-row  :data="tableData_copy.slice((pageInfo_copy.currentPage-1)*pageInfo_copy.pageSize,pageInfo_copy.currentPage*pageInfo_copy.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table">
              <el-table-column v-for="(item,index) in tableTitleOri" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
              </el-table-column>
            </el-table>
            <!--分页器-->
            <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo_copy.currentPage" :page-size="pageInfo_copy.pageSize" :total="tableData_copy.length" @size-change="handleSizeChange_copy" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange_copy">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>
  import api from '../assets/javascript/api'
  import qs from 'qs'

  export default {
    name: "导入DXF数据",
    data(){
      return{
        /*文件上传的地址*/
        action:api + 'dxf/dxf',
        /*通过key刷新表格*/
        table:1,
        /*防止重复点击*/
        repeat:false,
        /*上传文件的列表*/
        fileList:[],
        /*环境信息分页器的参数*/
        pageInfo: {
          currentPage: 1,
          pageSize: 5,
        },
        /*障碍物信息分页器的参数*/
        pageInfo_copy: {
          currentPage: 1,
          pageSize: 5,
        },
        /*表格的最大高度*/
        tableHeight:'',
        /*DXF环境信息表格组件渲染数组*/
        tableTitleEnv:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"图层名",width:"",prop:"laneLineType",show:true},
          {label:"#线",width:"",prop:"line",show:true},
          {label:"#点",width:"",prop:"point",show:true},
          {label:"X",width:"",prop:"coordinateX",show:true},
          {label:"Y",width:"",prop:"coordinateY",show:true},
          {label:"Z",width:"",prop:"coordinateZ",show:true},
        ],
        /*DXF障碍物信息表格组件渲染数组*/
        tableTitleOri:[
          {label:"案例编号",width:"120",prop:"caseNumber",show:false},
          {label:"图层名",width:"",prop:"type",show:true},
          {label:"#线",width:"",prop:"line",show:true},
          {label:"#点",width:"",prop:"point",show:true},
          {label:"X",width:"",prop:"coordinateX",show:true},
          {label:"Y",width:"",prop:"coordinateY",show:true},
          {label:"Z",width:"",prop:"coordinateZ",show:true},
        ],
        /*环境信息表格数据*/
        tableData: [],
        /*障碍物信息表格数据*/
        tableData_copy: [],
      }
    },
    methods:{
      /*文件上传成功*/
      uploadSuc(res){
        if(res.code === "0000"){
          /*对返回的数据进行处理，去掉外包装*/
          let obstaclePageDto = res.data.obstaclePageDto.data;
          let scenePageDto = res.data.scenePageDto.data;
          /*双重循环遍历返回的数组并存值*/
          for(let i = 0;i < obstaclePageDto.length;i++) {
            let obj = [];
            for (let key of Object.keys(obstaclePageDto)) {
              obj[key] = obstaclePageDto[key];
            }
            this.tableData_copy = obj;
          }
          for(let i = 0;i < scenePageDto.length;i++){
            let obj = [];
            for(let key of Object.keys(scenePageDto)){
              obj[key] = scenePageDto[key];
            }
            this.tableData = obj;
          }
        }
        else{
          this.$message({
            message: res.msg,
            type: 'error',
            duration:1500
          });
          this.fileList = [];
        }
      },
      /*文件上传失败*/
      uploadErr(err){
        this.$message({
          message: err.msg,
          type: 'error',
          duration:1500
        });
      },
      /*文件个数大于1*/
      uploadMore(){
        this.$message({
          message: '一次仅限上传一个文件',
          type: 'error',
          duration:1000
        });
      },
      /*移除文件列表*/
      uploadRem(){
        this.fileList = [];
        this.$message({
          message: '删除成功',
          type: 'success',
          duration:1000
        });
      },
      /*保存DXF数据*/
      saveCase(){
        /*禁用按钮防止误触*/
        this.repeat = true;
        let postData;
        if(this.tableData_copy.length > 0){
          postData = qs.stringify({
            caseNumber:this.tableData_copy[0].caseNumber
          });
        }
        else{
         postData = qs.stringify({
            caseNumber:this.tableData[0].caseNumber
          });
        }
        this.$http.post(
          '/dxf/dxf/sd',
          postData,
          {
            headers:
              {'Content-Type':'application/x-www-form-urlencoded'}
          })
          .then((res)=>{
            this.$message({
              message: "保存成功",
              type: 'success',
              center: true,
              duration:1500
            });
            this.fileList = [];
            this.repeat = false;
          })
          .catch((error)=>{
            console.log(error);
            this.repeat = false;
          })
      },
      /* 环境信息分页大小切换*/
      handleSizeChange(val) {
        this.pageInfo.pageSize = val;
      },
      /*环境信息分页切换*/
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val;
      },
      /* 障碍物信息分页大小切换*/
      handleSizeChange_copy(val) {
        this.pageInfo_copy.pageSize = val;
      },
      /*障碍物信息分页切换*/
      handleCurrentChange_copy(val) {
        this.pageInfo_copy.currentPage = val;
      },
      /*获取高度*/
      getHeight(){
        /*定义两个高度，初始高度和现在高度*/
        let nowH;
        /*延迟获取当前高度*/
        this.$nextTick(()=>{
          nowH = this.$refs.dataEnv.offsetHeight - 36;
        });
        let height = this.tableHeight;
        /*比对操作*/
        if(nowH !== height){
          this.tableHeight = nowH;
          this.table++;
        }
      }
    },
    mounted(){
      /*当真实DOM渲染完成后调用该钩子获取当前data元素的高度并保存*/
      /*在created调用会报bug因为页面初始化时vue生命周期中先虚拟DOM，此时真实的DOM还没有挂载，无法获取*/
      this.$nextTick(()=>{
        this.tableHeight = this.$refs.dataEnv.offsetHeight - 36;
      });
    },
    created(){
      /*在页面初始化时调用获取实时高度函数*/
      this.getHeight();
    }
  }
</script>

<style scoped>
  .el-main{
    padding: 0;
  }
  .importDXF{
    width: 100%;
    height: calc(100% - 34px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .topButton{
    background-color: #E9EBEE;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
  }
  .tabs{
    width: 100%;
    height: calc(100% - 50px);
    border: none;
  }
  .el-tab-pane{
    width: 100%;
    height: 100%;
  }
  .data{
    width: 100%;
    height: 100%;
  }
  .el-pagination{
    text-align: center;
  }
  .upload{
    display: flex;
    align-items: center;
    height: 100%;
    width: 35%;
    padding-left: 2%;
  }
  .save{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    width: 60% ;
    padding-right: 2%;
  }
  .uploadBut{
    background-color: cadetblue;
  }
</style>
<style>
  .tabs .el-tabs__content{
    width: 100%;
    height: calc(100% - 40px);
    padding: 0 !important;
  }
</style>





// WEBPACK FOOTER //
// src/importData/importDXF.vue